import {
  SpeakingLevel,
  UserActivityRangesInput,
  UserListSortDirection,
  UserListSortField,
} from "../gql/graphql.ts";
import { isEmptyRange, NumberRange } from "../UI/Table/numberRange.ts";

export type UserTableSort = {
  sortBy: UserListSortField;
  sortDirection: UserListSortDirection;
};

export const DEFAULT_USER_TABLE_SORT: UserTableSort = {
  sortBy: UserListSortField.CreatedAt,
  sortDirection: UserListSortDirection.Desc,
};

export function isDefaultUserTableSort(sort: UserTableSort): boolean {
  return (
    sort.sortBy === DEFAULT_USER_TABLE_SORT.sortBy &&
    sort.sortDirection === DEFAULT_USER_TABLE_SORT.sortDirection
  );
}

export type UserActivityCounterName = keyof UserActivityRangesInput;

export type UserTableFilters = {
  speakingLevels: SpeakingLevel[];
  activityRanges: Partial<Record<UserActivityCounterName, NumberRange>>;
};

export const SPEAKING_LEVELS_FROM_HIGHEST: SpeakingLevel[] = [
  SpeakingLevel.Voyagers,
  SpeakingLevel.Pioneers,
  SpeakingLevel.Navigators,
  SpeakingLevel.Explorers,
  SpeakingLevel.Starters,
  SpeakingLevel.Unknown,
];

export function toActivityRangesInput(
  activityRanges: UserTableFilters["activityRanges"],
): UserActivityRangesInput | undefined {
  const activeRanges = Object.entries(activityRanges).filter(
    ([, range]) => range && !isEmptyRange(range),
  );
  return activeRanges.length > 0 ? Object.fromEntries(activeRanges) : undefined;
}
